import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { DeploymentsSection } from "@/features/omnimizer/components/DeploymentsSection";
import { FastSwitchPage } from "@/features/omnimizer/components/FastSwitchPage";
import { canModifyDeployments } from "@/features/omnimizer/permissions";

type FastSwitchSearch = { cluster?: string };

const FastSwitchRoute = () => {
  const { t } = useTranslation();
  const { cluster } = Route.useSearch();
  const navigate = useNavigate({ from: "/deployments/fast-switch" });
  return (
    <DeploymentsSection section="switch" description={t("omnimizer.fastSwitch.description")}>
      <FastSwitchPage
        clusterId={cluster}
        onCluster={(id) => void navigate({ search: { cluster: id }, replace: true })}
        canSwitch={canModifyDeployments()}
      />
    </DeploymentsSection>
  );
};

export const Route = createFileRoute("/deployments/fast-switch")({
  validateSearch: (search: Record<string, unknown>): FastSwitchSearch => ({
    cluster: typeof search.cluster === "string" ? search.cluster : undefined,
  }),
  component: FastSwitchRoute,
});
